import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareAppsRoute: InvariantJiraRoute = {
	name: 'project-settings-software-apps',
	path: '/jira/software/projects/:projectKey/settings/apps/:appId?',
	exact: true,
};
